const PLAYER_ID_KEY = 'dad_playerId';
const ROOM_CODE_KEY = 'dad_roomCode';
const PLAYER_NAME_KEY = 'dad_playerName';

export interface StoredSession {
  playerId: string;
  roomCode: string;
  playerName: string;
}

export function loadStoredSession(): StoredSession | null {
  const playerId = localStorage.getItem(PLAYER_ID_KEY);
  const roomCode = localStorage.getItem(ROOM_CODE_KEY);
  const playerName = localStorage.getItem(PLAYER_NAME_KEY);
  if (!playerId || !roomCode || !playerName) return null;
  return { playerId, roomCode, playerName };
}

export function saveSession(roomCode: string, playerId: string, playerName: string): void {
  localStorage.setItem(PLAYER_ID_KEY, playerId);
  localStorage.setItem(ROOM_CODE_KEY, roomCode);
  localStorage.setItem(PLAYER_NAME_KEY, playerName);
}

export function clearSession(): void {
  localStorage.removeItem(PLAYER_ID_KEY);
  localStorage.removeItem(ROOM_CODE_KEY);
  localStorage.removeItem(PLAYER_NAME_KEY);
}

export function getStoredPlayerId(): string | null {
  return localStorage.getItem(PLAYER_ID_KEY);
}
